import { useContext } from 'react'

import { connect, useData } from 'scrivito'

import { EntityListContext } from './EntityListContext'
import { Loading } from './Loading'

export const EntityListLoadingIndicator = connect(
  function EntityListLoadingIndicator() {
    const dataScope = useData()
    const { hasMore } = useContext(EntityListContext)

    // subscribe to dataScope.take() and hasMore() loading
    dataScope.take()
    hasMore()

    return null
  },
  { loading: Loading },
)
